import styled from "styled-components";

export const MainLabel = styled.label`
    font-size: 13px;
    color: ${({theme}) => theme.color.text_color_100};
    font-weight: 700;
`

export const MainInput = styled.input`
    width: 100%;
    height: fit-content;
    font-size: 14px;
    padding: 11px 12px;
    border-radius: 6px;
    color: ${({theme}) => theme.color.text_color_200};
    background-color: ${({theme}) => theme.color.primary_100};
    border: 1px solid ${({theme}) => theme.color.primary_300};
    transition: background-color 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;

    &:focus {
        outline: none;
        border-color: ${({theme}) => theme.color.point_y_100};
        box-shadow: 0 0 0 3px ${({ theme }) => theme.name === 'dark' ? 'rgba(109, 141, 255, 0.18)' : 'rgba(63, 99, 216, 0.12)'};
    }

    &::placeholder {
        color: ${({theme}) => theme.color.text_color_400};
    }

    &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px ${({theme}) => theme.color.primary_50} inset;
        -webkit-text-fill-color: ${({theme}) => theme.color.text_color_200};
    }
`;

export const MainSelect = styled.select`
    width: 100%;
    height: fit-content;
    font-size: 14px;
    padding: 11px 36px 11px 12px;
    border-radius: 6px;
    color: ${({theme}) => theme.color.text_color_200};
    background-color: ${({theme}) => theme.color.primary_100};
    border: 1px solid ${({theme}) => theme.color.primary_300};
    transition: background-color 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;

    &:focus {
        outline: none;
        border-color: ${({theme}) => theme.color.point_y_100};
        box-shadow: 0 0 0 3px ${({ theme }) => theme.name === 'dark' ? 'rgba(109, 141, 255, 0.18)' : 'rgba(63, 99, 216, 0.12)'};
    }

    option {
        background-color: ${({theme}) => theme.color.primary_100};
        color: ${({theme}) => theme.color.text_color_100};
    }
`;

export const MainTextArea = styled.textarea`
    width: 100%;
    height: fit-content;
    font-size: 14px;
    padding: 11px 12px;
    border-radius: 6px;
    color: ${({theme}) => theme.color.text_color_200};
    background-color: ${({theme}) => theme.color.primary_100};
    border: 1px solid ${({theme}) => theme.color.primary_300};
    transition: background-color 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;
    resize: none;

    &:focus {
        outline: none;
        border-color: ${({theme}) => theme.color.point_y_100};
        box-shadow: 0 0 0 3px ${({ theme }) => theme.name === 'dark' ? 'rgba(109, 141, 255, 0.18)' : 'rgba(63, 99, 216, 0.12)'};
    }

    &::placeholder {
        color: ${({theme}) => theme.color.text_color_400};
    }
`;

/** Login Main* controls stay above; business forms use these exports. */
export const ConsoleInput = styled.input`
    width: 100%; min-width: 0; height: 36px; padding: 0 11px;
    border: 1px solid ${({ theme }) => theme.color.primary_400}; border-radius: 6px;
    background: ${({ theme }) => theme.color.primary_100}; color: ${({ theme }) => theme.color.text_color_100};
    font: inherit; font-size: 13px; line-height: 20px;
    color-scheme: ${({ theme }) => theme.name};
    &::placeholder { color: ${({ theme }) => theme.color.text_color_300}; }
    &:focus { outline: 2px solid ${({ theme }) => theme.color.point_y_100}; outline-offset: 1px; border-color: ${({ theme }) => theme.color.point_y_100}; }
    &:disabled, &[readonly] { background: ${({ theme }) => theme.color.primary_50}; color: ${({ theme }) => theme.color.text_color_200}; }
    &[aria-invalid='true'] { border-color: ${({ theme }) => theme.color.point_n_100}; }
`;
export const ConsoleSelect = styled(ConsoleInput).attrs({ as: 'select' })`
    padding-right: 28px; cursor: pointer;
`;
export const ConsoleTextArea = styled(ConsoleInput).attrs({ as: 'textarea' })`
    height: auto; min-height: 88px; padding: 9px 11px; resize: vertical;
`;
export const ConsoleLabel = styled.label`
    display: block; color: ${({ theme }) => theme.color.text_color_200}; font-size: 12px; font-weight: 500;
`;
export const FormGroup = styled.div`
    display: flex; flex-direction: column; gap: 6px; margin-bottom: 16px; min-width: 0;
`;
export const FormActions = styled.div`
    display: flex; justify-content: flex-end; align-items: center; gap: 8px;
`;
export const FieldError = styled.p`
    color: ${({ theme }) => theme.color.point_n_100}; font-size: 12px; line-height: 18px; margin: 0;
`;
